import { useState } from "react";
import { Clock, MapPin, Instagram, ChevronDown, ExternalLink } from "lucide-react";
import QRCode from "react-qr-code";

export function InfoCards() {
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);

  return (
    <div className="mt-10 px-4 grid gap-4">
      {/* Schedule Card - Collapsible Timeline */}
      <div
        className="bg-card dark:bg-cream-dark p-6 rounded-xl border-2 border-primary/20 dark:border-primary/10 rough-shadow hover-lift cursor-pointer"
        onClick={() => setIsScheduleOpen(!isScheduleOpen)}
      >
        <div className="flex items-start justify-between">
          <div className="flex items-start space-x-4">
            <div className="bg-primary/10 dark:bg-primary/20 p-3 rounded-full shrink-0">
              <Clock className="text-primary w-6 h-6" />
            </div>
            <div>
              <h3 className="font-display text-xl text-primary mb-1 rotate-slight">KOREAN WORSHIP</h3>
              <p className="font-bold text-card-foreground">Every Thursday</p>
              {!isScheduleOpen && (
                <p className="text-sm text-muted-foreground font-hand">Tap to see schedule</p>
              )}
            </div>
          </div>
          <ChevronDown
            className={`text-primary w-5 h-5 transition-transform duration-300 ${
              isScheduleOpen ? "rotate-180" : ""
            }`}
          />
        </div>

        {/* 3-Step Timeline - Collapsible */}
        <div
          className={`overflow-hidden transition-all duration-300 ${
            isScheduleOpen ? "max-h-48 opacity-100 mt-4" : "max-h-0 opacity-0"
          }`}
        >
          <div className="ml-2 border-l-2 border-primary/30 pl-4 space-y-3">
            <div className="relative">
              <div className="absolute -left-[21px] w-3 h-3 bg-primary rounded-full"></div>
              <span className="font-bold text-primary text-sm">6:00 PM</span>
              <p className="text-card-foreground text-sm font-body">Dinner & Fellowship</p>
            </div>
            <div className="relative">
              <div className="absolute -left-[21px] w-3 h-3 bg-primary rounded-full"></div>
              <span className="font-bold text-primary text-sm">7:00 PM</span>
              <p className="text-card-foreground text-sm font-body">Worship & Message</p>
            </div>
            <div className="relative">
              <div className="absolute -left-[21px] w-3 h-3 bg-primary rounded-full"></div>
              <span className="font-bold text-primary text-sm">8:15 PM</span>
              <p className="text-card-foreground text-sm font-body">Prayer & Fellowship</p>
            </div>
          </div>
        </div>
      </div>

      {/* Location Card */}
      <div
        className="bg-card dark:bg-cream-dark p-6 rounded-xl border-2 border-primary/20 dark:border-primary/10 rough-shadow relative overflow-hidden hover-lift cursor-pointer"
        onClick={() => window.open("https://maps.google.com/?q=3637+Chestnut+St,+Philadelphia,+PA+19104", "_blank")}
      >
        <div className="flex items-start space-x-4">
          <div className="bg-primary/10 dark:bg-primary/20 p-3 rounded-full shrink-0 z-10">
            <MapPin className="text-primary w-6 h-6" />
          </div>
          <div className="z-10 flex-1">
            <h3 className="font-display text-xl text-primary mb-1 rotate-slight">LOCATION</h3>
            <p className="font-bold text-card-foreground text-lg leading-tight">University Lutheran Church</p>
            <p className="text-sm text-muted-foreground mt-1">3637 Chestnut St, Philadelphia, PA 19104</p>
            <p className="text-xs text-muted-foreground font-hand mt-1">Tap to open in Google Maps</p>
          </div>
        </div>
        {/* Venue Website Link */}
        <a
          href="https://www.uniluphila.org/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="mt-3 inline-flex items-center gap-1 text-sm text-primary hover:underline font-body"
        >
          <ExternalLink className="w-3 h-3" />
          Visit venue website
        </a>
        {/* Decorative Pattern */}
        <div className="absolute right-0 top-0 bottom-0 w-24 opacity-10 pointer-events-none">
          <svg height="100%" preserveAspectRatio="none" viewBox="0 0 100 100" width="100%">
            <path d="M10,0 L20,100 M40,0 L30,100 M60,0 L80,100" stroke="currentColor" strokeWidth="2"></path>
            <path d="M0,30 L100,20 M0,70 L100,80" stroke="currentColor" strokeWidth="2"></path>
          </svg>
        </div>
      </div>

      {/* Social Card with QR Code */}
      <div
        className="bg-primary p-6 rounded-xl rough-shadow text-primary-foreground flex justify-between items-center hover-lift cursor-pointer"
        onClick={() => window.open("https://www.instagram.com/jcministry_/", "_blank")}
      >
        <div>
          <h3 className="font-display text-2xl mb-1">STAY CONNECTED</h3>
          <div className="flex items-center space-x-2">
            <Instagram className="w-5 h-5" />
            <span className="font-hand text-xl">@jcministry_</span>
          </div>
          <p className="text-xs opacity-80 mt-1 font-body">Tap to follow us</p>
        </div>
        <div className="bg-white p-2 rounded-lg rough-shadow shrink-0">
          <QRCode
            value="https://www.instagram.com/jcministry_/"
            size={64}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}